import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";

// Thunk for fetching health issues of a specific student
export const fetchHealthIssue = createAsyncThunk(
  "HealthIssue/fetchStudentHealthIssue",
  async (studentId) => {
    try {
      const storedToken = localStorage.getItem("token");
           console.log("1-----------------studentId", studentId);

      if (!storedToken || !studentId) {
        throw new Error("No authorization token or studentId found");
      }
           console.log("2-----------------storedToken", storedToken);

      const response = await fetch(
        `${API_BASE_URL}/api/HealthIssue/find/${studentId}`,
        {
          headers: { Authorization: `Bearer ${storedToken}` },
        }
      );
           console.log("3-----------------response", response);

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch health issue: ${errorText}`);
      }

      // Ensure we return an array
      const data = await response.json();
      console.log("-----------------data", data);
      return Array.isArray(data) ? data : [data]; // Adjusting to always return an array
    } catch (error) {
      console.error("Error fetching health issue:", error);
      throw error;
    }
  }
);
// Thunk for fetching health issues of all students for the logged-in user
export const fetchAllHealthIssues = createAsyncThunk(
  "HealthIssue/fetchAllStudentHealthIssues",
  async (_, { dispatch }) => {
    try {
      const storedUser = localStorage.getItem("userInfo");
      const userData = storedUser ? JSON.parse(storedUser) : null;
      const storedToken = localStorage.getItem("token");
      console.log("0-----------------data", userData);
      if (!userData || !storedToken) {
        throw new Error("No user data or token found");
      }

      const allHealthIssues = [];
      for (const studentId of userData.studentIds) {
        console.log("0-----------------studentId", studentId);
        // Await the response and store it in a variable
        const response = await dispatch(fetchHealthIssue(studentId)).unwrap(); // Use unwrap to handle the payload directly
        // Ensure response is an array and spread into allHealthIssues
        if (Array.isArray(response)) {
          allHealthIssues.push(...response);
        } else {
          console.warn(
            `Expected an array for studentId ${studentId}, but received:`,
            response
          );
        }
      }

      return allHealthIssues; // Return all health issues
    } catch (error) {
      console.error("Error fetching all health issues:", error);
      throw error; // Rethrow the error for Redux to handle it
    }
  }
);

export const createHealthIssue = createAsyncThunk(
  "healthIssue/createHealthIssue",
  async ({ studentId, healthData }, { rejectWithValue }) => {
    try {
      const dataToSubmit = {
        issueName: healthData.issueName,
        issueType: healthData.issueType,
        studentId: studentId,
      };

      const storedToken = localStorage.getItem("token");
      console.log("1dataToSubmit", dataToSubmit);
      console.log("2storedToken", storedToken);

      if (!storedToken) {
        return rejectWithValue("No authorization token found");
      }
      console.log("--------------dataToSubmit", dataToSubmit);
      const response = await fetch(`${API_BASE_URL}/api/HealthIssue/Create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${storedToken}`,
        },
        body: JSON.stringify(dataToSubmit),
      });

      if (!response.ok) {
        const errorText = await response.text();
        return rejectWithValue(`Failed to create health issue: ${errorText}`);
      }

      const data = await response.json();
       console.log("--------------data", data);
     return data; // Return the created health information
    } catch (error) {
      return rejectWithValue("Error creating health issue:", error);
    }
  }
);

// Function to update health information
export const updateHealthIssue = createAsyncThunk(
  "healthInfo/updateHealthInfo",
  async ({ studentId, healthData }, rejectWithValue) => {
    try {
      const dataToSubmit = {
        issueName: healthData.issueName,
        issueType: healthData.issueType,
        studentId: studentId,
      };

      const storedToken = localStorage.getItem("token");
      console.log("dataToSubmit", dataToSubmit);

      if (!storedToken) {
        return rejectWithValue("No authorization token found");
      }

      const response = await fetch(
        `${API_BASE_URL}/api/HealthIssue/Update/${healthData.issueID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storedToken}`,
          },
          body: JSON.stringify(dataToSubmit),
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        return rejectWithValue(`Failed to update health info: ${errorText}`);
      }

      const data = await response.json();
      return data; // Return the updated health information
    } catch (error) {
      return rejectWithValue("Error updating health info:", error);
    }
  }
);

const healthInfoSlice = createSlice({
  name: "healthIssue",
  initialState: {
    healthIssueList: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchHealthIssue.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHealthIssue.fulfilled, (state, action) => {
        state.loading = false;
        state.healthIssueList = action.payload;
      })
      .addCase(fetchHealthIssue.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(fetchAllHealthIssues.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllHealthIssues.fulfilled, (state, action) => {
        state.loading = false;
        state.healthIssueList = action.payload; // Update with all students' issues
      })
      .addCase(fetchAllHealthIssues.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const healthIssueSelector = (state) => state.healthIssue;

export default healthInfoSlice.reducer;
